import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    Table, TableRow, TableCell, TableHead, TableBody,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useEffectAsync } from '../reactHelper';
import { useTranslation } from '../common/components/LocalizationProvider';
import { prefixString } from '../common/util/stringUtils';
import PageLayout from '../common/components/PageLayout';
import SettingsMenu from './components/SettingsMenu';
import CollectionFab from './components/CollectionFab';
import CollectionActions from './components/CollectionActions';
import TableShimmer from '../common/components/TableShimmer';
import SearchHeader, { filterByKeyword } from './components/SearchHeader';
import { useRestriction } from '../common/util/permissions';
import { commandsActions } from '../store';

const useStyles = makeStyles((theme) => ({
    columnAction: {
        width: '1%',
        paddingRight: theme.spacing(1),
    },
}));

const CommandsPage = () => {
    const classes = useStyles();
    const t = useTranslation();

    const dispatch = useDispatch();
    const items = useSelector((state) => state.commands.items);
    const loaded = useSelector((state) => state.commands.loaded);
    const [searchKeyword, setSearchKeyword] = useState('');
    const limitCommands = useRestriction('limitCommands');

    useEffectAsync(async () => {
        if (!loaded) {
            try {
                const response = await fetch('/api/tracking/commands');
                if (response.ok) {
                    const result = await response.json();
                    dispatch(commandsActions.update(result));
                } else {
                    throw Error(await response.text());
                }
            } catch {
                throw Error('Error');
            }
        }
    }, []);

    return (
        <PageLayout menu={<SettingsMenu />} breadcrumbs={['settingsTitle', 'sharedSavedCommands']}>
            <SearchHeader keyword={searchKeyword} setKeyword={setSearchKeyword} />
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>{t('sharedDescription')}</TableCell>
                        <TableCell>{t('sharedType')}</TableCell>
                        {!limitCommands && <TableCell className={classes.columnAction} />}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {loaded ? Object.values(items).filter(filterByKeyword(searchKeyword)).map((item) => (
                        <TableRow key={item.id}>
                            <TableCell>{item.description}</TableCell>
                            <TableCell>{t(prefixString('command', item.type))}</TableCell>
                                <TableCell className={classes.columnAction} padding="none">
                                    <CollectionActions
                                        itemId={item.id}
                                        editPath="/settings/command"
                                        endpoint="commands"
                                        removeAction={commandsActions.remove}
                                    />
                                </TableCell>
                        </TableRow>
                    )) : (<TableShimmer columns={limitCommands ? 2 : 3} endAction />)}
                </TableBody>
            </Table>
            <CollectionFab editPath="/settings/command" disabled={limitCommands} />
        </PageLayout>
    );
};

export default CommandsPage;
